import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    fontFamily: 'TWKLausanne',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  container: {
    flex: 1,
    display: 'flex',
    paddingHorizontal: 24,
  },

  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral900,
  },

  bottomContainer: {
    maxWidth: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },

  bankData: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 10,
  },

  note: {
    fontWeight: 700,
    fontSize: 10,
    textTransform: 'uppercase',
    marginBottom: 2,
    color: colors.neutral900,
  },

  noteContainer: {
    marginTop: 10,
  },

  payButtonView: {
    borderRadius: 6,
    overflow: 'hidden',
  },

  payButton: {
    height: 42,
    width: 272,
    backgroundColor: colors.primary,
    color: colors.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  payButtonLabel: {
    fontSize: 14,
    fontWeight: 450,
    textDecoration: 'none',
    color: colors.white,
  },

  productTable: { paddingHorizontal: 0, marginTop: 0 },

  productTablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 20,
  },
});
